<div class="dialog-header">
  <div class="dialogTitle">Point Cloud Configuration</div>
  <mat-icon class="dialogCloseIcon" svgIcon="dialog.close" (click)="closeDialog(buttonsInfo[0].value)"></mat-icon>
</div>
<div class="dialog-content">
  <div class="label">Define Point Cloud Configuration: </div>
  <div class="tableActionPanel">
    <div class="actionItem" (click)="addConfiguration()">
      <span class="icon">
        <mat-icon svgIcon="addIcon" insTooltip [delayMs]="1000" [cfg]="{text: 'Add Service Account', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
      </span>
      <span class="iconLabel">Add Account</span>
    </div>
    @if (selectedRowIndex !== -1) {
      <div class="actionItem" (click)="editConfiguration()">
        <span class="icon">
          <mat-icon class="addNewRowIcon icon" svgIcon="pencilIcon" insTooltip [delayMs]="1000" [cfg]="{text: 'Edit Service Account', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
        </span>
        <span class="iconLabel">Edit Account</span>
      </div>
    }
    @if (selectedRowIndex !== -1) {
      <div class="actionItem" (click)="deleteConfiguration()">
        <span class="icon">
          <mat-icon class="removeRowIcon icon" svgIcon="removeIcon" insTooltip [delayMs]="1000" [cfg]="{text: 'Remove Service Account', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
        </span>
        <span class="iconLabel">Delete Account</span>
      </div>
    }
    @if (selectedRowIndex !== -1) {
      <div class="actionItem" (click)="testPointCloudConnection()">
        <span class="icon">
          <mat-icon class="removeRowIcon icon" svgIcon="connection" insTooltip [delayMs]="1000" [cfg]="{text: 'Clear All Service Accounts', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
        </span>
        <span class="iconLabel">Check Connection</span>
      </div>
    }

    <div class="searchPanel">
      <div class="searchContainer lightBackground">
        <input class="searchField" type="text" [(ngModel)]="searchStr" placeholder="Search by Account Name" (keyup)="searchStrChanged(searchStr)">
        @if (searchStr !== '') {
          <div class="clearButton" (click)="clearSearchStr()" (keyup)="onClearButtonKeyUp($event)">clear</div>
        }
        <mat-icon class="searchIcon" svgIcon="sites.search"></mat-icon>
      </div>
      @if (searchStr) {
        <div class="filteredDataCount">{{filteredDataCount}} results found</div>
      }
    </div>
  </div>
  <div class="ins-table-Container">
    <perfect-scrollbar class="scrollbar">
      <table mat-table [dataSource]="confDataSource" matSort class="ins-table" (matSortChange)="onSortChange($event)" id="pointcloud-conf-table">
        <caption></caption>
        <!-- Select -->
        <ng-container matColumnDef="select">
          <th mat-header-cell class="header-cell" *matHeaderCellDef mat-sort-header></th>
          <td mat-cell class="body-cell" *matCellDef="let element; let i = index">
            {{i + 1}}
          </td>
        </ng-container>

        <!-- Name -->
        <ng-container matColumnDef="name">
          <th mat-header-cell class="header-cell" *matHeaderCellDef mat-sort-header> Service Account Name</th>
          <td mat-cell class="body-cell" *matCellDef="let element" [delayMs]="700" #nameDiv insTooltip [cfg]="getToolTipConf(nameDiv, element.name)">
            {{element.name}}
          </td>
        </ng-container>

        <!-- Domain Host -->
        <ng-container matColumnDef="domainHost">
          <th mat-header-cell class="header-cell" *matHeaderCellDef mat-sort-header> Domain Host</th>
          <td mat-cell class="body-cell" *matCellDef="let element" [delayMs]="700" #nameDiv insTooltip [cfg]="getToolTipConf(nameDiv, element.domainHost)">
            {{element.domainHost}}
          </td>
        </ng-container>

        <!-- Subject -->
        <ng-container matColumnDef="subject">
          <th mat-header-cell class="header-cell" *matHeaderCellDef mat-sort-header> Subject Email</th>
          <td mat-cell class="body-cell" *matCellDef="let element" [delayMs]="700" #nameDiv insTooltip [cfg]="getToolTipConf(nameDiv, element.subject)">
            {{element.subject}}
          </td>
        </ng-container>

        <!-- Audience -->
        <ng-container matColumnDef="audience">
          <th mat-header-cell class="header-cell" *matHeaderCellDef mat-sort-header> Audience</th>
          <td mat-cell class="body-cell" *matCellDef="let element" [delayMs]="700" #nameDiv insTooltip [cfg]="getToolTipConf(nameDiv, element.audience)">
            {{element.audience}}
          </td>
        </ng-container>

        <!-- Issuer -->
        <ng-container matColumnDef="issuer">
          <th mat-header-cell class="header-cell" *matHeaderCellDef mat-sort-header> Issuer</th>
          <td mat-cell class="body-cell" *matCellDef="let element" [delayMs]="700" #nameDiv insTooltip [cfg]="getToolTipConf(nameDiv, element.issuer)">
            {{element.issuer}}
          </td>
        </ng-container>

        <tr mat-header-row class="header-row" *matHeaderRowDef="confColumns; sticky: true"></tr>
        <tr mat-row class="body-row" (click)="onRowClicked(row, i, $event)" [ngClass]="{ 'disable-row': isConfRowDisabled(row), 'highlight-row-border': i == selectedRowIndex }" *matRowDef="let row; columns: confColumns; let i = index"></tr>
      </table>
      @if (!showLoading && noData | async) {
        <div class="no-records" style="padding: 85px;">
          Service accounts are not defined.
        </div>
      }

      @if (showLoading) {
        <div class="no-records">
          Loading...
        </div>
      }
    </perfect-scrollbar>
  </div>
</div>
<div class="dialog-footer">
  <button class="actionButton white minWidth" (click)="closeDialog(buttonsInfo[0].value)">{{buttonsInfo[0].displayValue}}</button>
</div>